import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import { AuthContext } from "context/AuthContext";
import React, { useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { AlertMessages } from "_constants/AlertMessages";
import { FileHelper } from "_helpers/FileHelper";
import MCSHeader from "../../components/MCSHeader";
import MCSLoading from "../../components/MCSLoading";
import { GlobalAlertContext } from "../../context/GlobalAlertContext";
import { DafVmidApi } from "../../services/daf.vmid.service";
import VmidTable from "./Components/VmidTable";

const AcquirerVmidList = () => {
  const [error, setError] = useState(null);
  const { promiseInProgress } = usePromiseTracker();
  const [tableData, setTableData] = useState(null);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("lastUpdatedOn");
  const [desc, setDesc] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [searchVal, setSearchVal] = useState(null);

  const pageSize = 10;

  function handleSearchChange(newSearchVal) {
    setPage(1);
    fetchData(1, sortBy, desc, newSearchVal);
  }

  const handleSortChange = async (sortBy = null, desc = false) => {
    fetchData(page, sortBy, desc, searchVal);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchData(newPage, sortBy, desc, searchVal);
  };

  const handleClickParametersDownload = (alertObj) => {
    DafVmidApi.downloadAcquirerVmidParametersFile()
      .then((response) => {
        FileHelper.DownloadFile(response);
      })
      .catch((error) => {
        alertObj.setErrorMessage(AlertMessages.UnexpectedError);
      });
  };

  const fetchData = async (page, sortBy, desc, searchVal) => {
    let skipCount = (page - 1) * pageSize;
    trackPromise(
      DafVmidApi.getAcquirerVmidList(skipCount, sortBy, desc, searchVal)
        .then((result) => {
          setTableData(result.data.items);
          setTotalCount(result.data.totalCount);
          setTotalPages(Math.ceil(result.data.totalCount / pageSize));
        })
        .catch((error) => setError(error))
    );
  };

  useEffect(() => {
    fetchData(1, sortBy, desc, searchVal);
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    return (
      <AuthContext.Consumer>
        {(data) => (
          <GlobalAlertContext.Consumer>
            {(alertObj) => (
              <>
                <Grid>
                  <MCSHeader header="View VMIDs" />
                  {promiseInProgress && <MCSLoading />}
                  {!promiseInProgress && tableData && (
                    <>
                      <Row>
                        <Col>
                          <ButtonGroup direction="right">
                            <ButtonText onClick={handleClickParametersDownload}>
                              DOWNLOAD VMID PARAMETERS FILE
                            </ButtonText>
                          </ButtonGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <VmidTable
                            user={data.user}
                            showFlag={false}
                            showParam={true}
                            selectedPage={page}
                            setSelectedPage={handlePageChange}
                            totalPages={totalPages}
                            ordered={sortBy}
                            setOrdered={setSortBy}
                            sortData={handleSortChange}
                            isDsc={desc}
                            setDsc={setDesc}
                            pageSize={pageSize}
                            totalCount={totalCount}
                            tableData={tableData}
                            handleSearchChange={handleSearchChange}
                            searchVal={searchVal}
                            setSearchVal={setSearchVal}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                </Grid>
              </>
            )}
          </GlobalAlertContext.Consumer>
        )}
      </AuthContext.Consumer>
    );
  }
};
export default AcquirerVmidList;
